module.exports = __webpack_public_path__ + "static/divas1s-6df24ed476a89e1a671390a94bde6d9f.jpg";